var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap"},[_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"title-form"},[_c('h2',[_vm._v("登 录")])]),_c('div',{attrs:{"id":"wxloader"}})])])
}]

export { render, staticRenderFns }